// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

export const Alert = t.struct(
    {
        type: t.String,
        reference: t.String,
        message: t.Any,
    },
    'Alert',
);

export const getDefaultState = () => new Alert({
    type: '',
    reference: '',
    message: null,
});
